/// <amd-module name="Build/Admin/Common/Constants" />
export namespace AgentHubViewKeys {
    export const Capabilities: string = "capabilities";
    export const Jobs: string = "jobs";
}

export namespace FwLinks {
    export const DeprecatedAgentHelpLink = "https://go.microsoft.com/fwlink/?linkid=851067";
    export const DetailedInstructionsLinkDarwin = "https://go.microsoft.com/fwlink/?LinkID=825114";
    export const DetailedInstructionsLinkLinux = "https://go.microsoft.com/fwlink/?LinkID=825115";
    export const DetailedInstructionsLinkWindows = "https://go.microsoft.com/fwlink/?LinkID=825113";
    export const PrerequisitesLinkDarwin = "https://aka.ms/vstsagentosxsystem";
    export const PrerequisitesLinkLinux = "https://aka.ms/vstsagentlinuxsystem";
    export const PrerequisitesLinkWindows = "https://aka.ms/vstsagentwinsystem";
    export const ElasticPoolTroubleshooting = "https://go.microsoft.com/fwlink/?linkid=2145884";
    export const ElasticPoolInstructions = "https://aka.ms/AAa5w5l";
    export const PrivatePoolInstructions = "https://aka.ms/AAa5w94";
    export const ParallelJobsDocs = "https://aka.ms/AAab5b6";
    export const AgentPoolsSecurityUrl = "https://aka.ms/agent-pools";
    export const EphemeralDiskInfo = "https://aka.ms/AzPipelines/ephemeral-os-disks";
}

export namespace PlanTypes {
    export const Build: string = "build";
}

export namespace PoolHubViewKeys {
    export const Agents: string = "agents";
    export const Analytics: string = "analytics";
    export const Checks: string = "checks";
    export const Details: string = "details";
    export const Diagnostics: string = "diagnostics";
    export const Jobs: string = "jobs";
    export const MaintenanceHistory: string = "maintenancehistory";
    export const Security: string = "security";
    export const Settings: string = "settings";
}

export namespace Routes {
    export const AccountSettingsRouteId: string = "ms.vss-admin-web.collection-admin-hub-route";
    export const ProjectSettingsRouteId: string = "ms.vss-admin-web.project-admin-hub-route";
    export const BuildResultRouteId: string = "ms.vss-build-web.ci-results-hub-route";
}

export namespace RouteValues {
    export const AccountPools: string = "agentpools";
    export const ProjectPools: string = "agentqueues";
    export const ServiceConnections: string = "adminservices";
}

export namespace QueryParams {
    export const AdminPivot: string = "adminPivot";
    export const AgentId: string = "agentId";
    export const AgentCloudId: string = "agentCloudId";
    export const BuildId: string = "buildId";
    export const JobId: string = "jobId";
    export const PoolId: string = "poolId";
    export const Project: string = "project";
    export const QueueId: string = "queueId";
    export const ResourceId: string = "resourceId";
    export const TabId: string = "view";
}

export namespace DataProviders {
    export const AgentCloudsList: string = "ms.vss-build-web.agent-clouds-list-data-provider";
    export const Jobs: string = "ms.vss-build-web.agent-jobs-data-provider";
    export const Pools: string = "ms.vss-build-web.agent-pools-data-provider";
    export const Pool: string = "ms.vss-build-web.agent-pool-data-provider";
    export const Queues: string = "ms.vss-build-web.agent-queues-data-provider";
    export const Queue: string = "ms.vss-build-web.agent-queue-data-provider";
    export const QueueSecurity: string = "ms.vss-build-web.agent-queue-security-data-provider";
    export const Agent: string = "ms.vss-build-web.agent-data-provider";
    export const AgentDefinitions: string = "ms.vss-build-web.admin-agent-definitions-data-provider";
    export const AgentPoolCreation: string = "ms.vss-build-web.agent-pool-creation-data-provider";
    export const ElasticPool: string = "ms.vss-build-web.elastic-pool-data-provider";
    export const CheckIssues: string = "ms.vss-pipelinechecks.checks-issues-provider";
}

export namespace ServiceIds {
    export const HeaderBreadcrumbService: string = "pools-admin-header-breadcrumb-service";
}

export namespace Permission {
    export const Manage: number = 8;
    export const View: number = 1;
}

export namespace Telemetry {
    export const Area: string = "Build";
    export const AgentCloudsAdminFeature: string = "Admin.AgentClouds";
    export const AgentCloudsView: string = "Admin.AgentCloudsView";
    export const AgentPoolAnalytics: string = "AgentPool.AnalyticsHub";
    export const PoolsAdminFeature: string = "Admin.Pools";
    export const PoolsListView: string = "Admin.PoolsListView";
    export const PoolView: string = "Admin.PoolView";
    export const AgentView: string = "Admin.AgentView";
    export const QueueChecksView: string = "Admin.QueueChecksView";
}

export namespace FilterKeys {
    export const Agent: string = "agent";
    export const AgentSpec: string = "agentSpec";
    export const Keyword: string = "keyword";
    export const Name: string = "name";
    export const PoolType: string = "poolType";
    export const Project: string = "project";
}

export namespace Assets {
    export const ZeroDataPng: string = "ms.vss-build-web/admin.tabs/zerodata.png";
}

export namespace ServiceEndpointConstants {
    export const AzureRMConnectionType: string = "azurerm";
    export const AzureTenantId: string = "tenantId";
}

export const enum StoreStatus {
    // No request made
    None,
    // Request in progress
    Loading,
    // Request finished
    Loaded
}

export namespace ConfigurationJob {
    export const VmssTimestampValidityHours: number = 4;
}